import buildQuery from "odata-query";
import { IColumnDl, IFilterQuery } from "@/DependenciesV9/DataTable/Model.ts";
import { FilterType, OperatorFilterNumberEnums } from "@/DependenciesV9/DataTable/Enums/TableEnum.ts";

export const buildEndpointWithSortAndFilter = (
  columns: IColumnDl[],
  filterQuery: IFilterQuery[],
  sortQueryClone: IFilterQuery | null
): string => {
  const columnsCustom: IColumnDl[] = columns;
  const crtQuery = [...filterQuery];
  const filterArr = crtQuery.filter((q) => q.type !== FilterType.Sort);
  let orderByAr: any[] = [];
  const filterWith: any[] = [];
  if(sortQueryClone && sortQueryClone.order && sortQueryClone.key) {
    const key: string = sortQueryClone.key.includes("=")
      ? sortQueryClone.key.replace("=", "")
      : sortQueryClone.key;
    orderByAr = [`${key} ${sortQueryClone.order}`];
    if(sortQueryClone.childQuery && sortQueryClone.order) {
      orderByAr = [`${sortQueryClone.childQuery} ${sortQueryClone.order}`];
    }
  }
  if(filterArr) {
    filterArr.forEach((f) => {
      const {key, value, operator, childQuery} = f;
      const conditionKey = childQuery ? childQuery : key;
      const isFilterOr = columnsCustom.findIndex(
        (col) =>
          col.key === key &&
          col.queryMultipleKeys &&
          col.queryMultipleKeys.length > 1
      );
      const isEnum = columnsCustom.some(
        (c) => c.key === key && c.isEnum
      );
      const isMultiple = columnsCustom.some(
        (c) => c.key === key && c.isMultiple
      );
      const isDateColumn = columnsCustom.some(
        (c) => c.key === key && c.data === "date"
      );
      switch(operator) {
        case "contains":
          if(Array.isArray(value)) {
            const startTimeArr = new Date(value[0].date);
            const monthKeep: number = startTimeArr.getMonth();
            const yearKeep: number = startTimeArr.getFullYear();
            startTimeArr.setUTCHours(0, 0, 0, 0);
            startTimeArr.setDate(new Date(value[0].date).getDate());
            startTimeArr.setMonth(monthKeep);
            startTimeArr.setFullYear(yearKeep);
            const endTimeArr = new Date(value[value.length - 1].date);
            endTimeArr.setUTCHours(23, 59, 59, 999);
            endTimeArr.setDate(
              new Date(value[value.length - 1].date).getDate() + 1
            );
            const filterDateArr = {
              [conditionKey]: {
                ge: startTimeArr,
                le: endTimeArr,
              },
            };
            if(isFilterOr !== -1) {
              const arr =
                columnsCustom[isFilterOr] &&
                columnsCustom[isFilterOr].queryMultipleKeys
                  ? columnsCustom[isFilterOr].queryMultipleKeys!
                  : [];
              const crtFilterContains: any = {};
              const orArr = arr.filter((k) => k !== conditionKey);
              if(orArr.length > 0) {
                orArr.forEach((i) => {
                  crtFilterContains[i] = {
                    ge: startTimeArr,
                    le: endTimeArr,
                  };
                });
                filterWith.push({or: crtFilterContains});
                break;
              }
            }
            filterWith.push(filterDateArr);
            break;
          } else {
            let val = `tolower('${value}')`;
            let filterContains = {
              [`tolower(${conditionKey})`]: {contains: val},
            };
            if(isEnum) {
              val = value;
              filterContains = {
                [conditionKey]: {contains: val},
              };
            }

            if(isFilterOr !== -1) {
              const arr =
                columnsCustom[isFilterOr] &&
                columnsCustom[isFilterOr].queryMultipleKeys
                  ? columnsCustom[isFilterOr].queryMultipleKeys!
                  : [];
              const crtFilterContains: any = {};
              if(arr.length > 0) {
                arr.forEach((i) => {
                  if(isEnum) {
                    crtFilterContains[i] = {contains: val};
                  } else {
                    crtFilterContains[`tolower(${i})`] = {contains: val};
                  }
                });
                filterWith.push({or: crtFilterContains});
                break;
              }
            }
            filterWith.push(filterContains);
            break;
          }
        case "not":
          if(Array.isArray(value)) {
            const startTimeNot = new Date(value[0].date);
            const monthKeepNot: number = startTimeNot.getMonth();
            const yearKeepNot: number = startTimeNot.getFullYear();
            startTimeNot.setUTCHours(0, 0, 0, 0);
            startTimeNot.setDate(new Date(value[0].date).getDate());
            startTimeNot.setMonth(monthKeepNot);
            startTimeNot.setFullYear(yearKeepNot);
            const endTimeNot = new Date(value[value.length - 1].date);
            endTimeNot.setUTCHours(23, 59, 59, 999);
            endTimeNot.setDate(
              new Date(value[value.length - 1].date).getDate() + 1
            );
            const filterDateArr = {
              not: {
                [conditionKey]: {ge: startTimeNot, le: endTimeNot},
              },
            };
            if(isFilterOr !== -1) {
              const arr =
                columnsCustom[isFilterOr] &&
                columnsCustom[isFilterOr].queryMultipleKeys
                  ? columnsCustom[isFilterOr].queryMultipleKeys!
                  : [];
              if(arr.length > 0) {
                const rs = arr.map((i) => {
                  return {
                    not: {
                      [i]: {
                        lt: startTimeNot,
                        gt: endTimeNot,
                      },
                    },
                  };
                });
                filterWith.push({and: rs});
                break;
              }
            }
            filterWith.push(filterDateArr);
            break;
          } else {
            let val = `tolower('${value}')`;
            let filterNot = {
              not: {[`tolower(${conditionKey})`]: {contains: val}},
            };
            if(isEnum) {
              val = value;
              filterNot = {
                not: {[conditionKey]: {contains: val}},
              };
            }
            if(isFilterOr !== -1) {
              const arr =
                columnsCustom[isFilterOr] &&
                columnsCustom[isFilterOr].queryMultipleKeys
                  ? columnsCustom[isFilterOr].queryMultipleKeys!
                  : [];
              if(arr.length > 0) {
                const rs = arr.map((i) => {
                  if(isEnum) {
                    return {not: {[i]: {contains: val}}};
                  }
                  return {not: {[`tolower(${i})`]: {contains: val}}};
                });
                filterWith.push({and: rs});
                break;
              }
            }
            filterWith.push(filterNot);
            break;
          }

        default: {
          let val: any = `tolower('${value}')`;
          let filterDefault = {
            [`tolower(${conditionKey})`]: {[operator]: val},
          };
          let filterEqual: Record<string, any> | null = null;
          const valIsDate: boolean =
            isDateColumn && isNaN(value) && !isNaN(new Date(value).getDate());
          if(
            value === undefined ||
            (typeof value === "string" && value.trim() === "")
          ) {
            val = null;
            if(operator === "ne") {
              filterDefault = {
                and: {
                  [conditionKey]: {[operator]: val},
                  [`tolower(${conditionKey})`]: {
                    [operator]: `tolower('${value}')`,
                  },
                },
              };
            } else {
              filterDefault = {
                or: {
                  [conditionKey]: {[operator]: val},
                  [`tolower(${conditionKey})`]: {
                    [operator]: `tolower('${value}')`,
                  },
                },
              };
            }
          } else if(
            typeof value === "boolean" ||
            typeof value === "number" ||
            isEnum ||
            (valIsDate && operator !== OperatorFilterNumberEnums.Equal)
          ) {
            const isTypeEnumNumber = columnsCustom.some(
              (c) => c.key === key && c.typeEnumKey === "number"
            );
            val = value;
            if(valIsDate) {
              val = new Date(value);
              filterDefault = {
                [conditionKey]: {[operator]: val},
              };
            } else if(isEnum && !isMultiple) {
              if(typeof value !== "boolean" && value?.includes("|")) {
                const splitValue = value.split("|");
                filterDefault = {
                  [conditionKey]: {
                    or: [
                      {
                        [operator]: isTypeEnumNumber
                          ? Number(splitValue[0])
                          : splitValue[0],
                      },
                      {
                        [operator]:
                          splitValue[1] === "isNull" ? null : splitValue[1],
                      },
                    ],
                  },
                };
              } else if(typeof value !== "boolean" && value?.includes("&")) {
                const splitValueQueryChild = value.split("&");
                let splitValueChild: string[] = [];
                if(splitValueQueryChild[1].includes(":")) {
                  splitValueChild = splitValueQueryChild[1].split(":");
                }
                filterDefault = {
                  [conditionKey]: {
                    [operator]: isTypeEnumNumber
                      ? Number(splitValueQueryChild[0])
                      : splitValueQueryChild[0],
                  },
                  [splitValueChild[0]]: {
                    [operator]: !isNaN(Number(splitValueChild[1]))
                      ? Number(splitValueChild[1])
                      : splitValueChild[1],
                  },
                };
              } else {
                val = isTypeEnumNumber ? Number(value) : value;
                filterDefault = {
                  [conditionKey]: {[operator]: val},
                };
              }
            } else if(isEnum && isMultiple && Array.isArray(value)) {
              filterDefault = {
                or: [],
              };
              value.forEach((item: string) => {
                if(item.includes("|")) {
                  const splitValue = item.split("|");
                  filterDefault.or.push({
                    [conditionKey]: {
                      [operator]: isTypeEnumNumber
                        ? Number(splitValue[0])
                        : splitValue[0],
                    },
                  });
                  filterDefault.or.push({
                    [conditionKey]: {
                      [operator]:
                        splitValue[1] === "isNull" ? null : splitValue[1],
                    },
                  });
                } else if(item?.includes("&")) {
                  const splitValueQueryChild = item.split("&");
                  let splitValueChild: string[] = [];
                  if(splitValueQueryChild[1].includes(":")) {
                    splitValueChild = splitValueQueryChild[1].split(":");
                  }
                  filterDefault.or.push({
                    and: [
                      {
                        [conditionKey]: {
                          [operator]: isTypeEnumNumber
                            ? Number(splitValueQueryChild[0])
                            : splitValueQueryChild[0],
                        },
                      },
                      {
                        [splitValueChild[0]]: {
                          [operator]: !isNaN(Number(splitValueChild[1]))
                            ? Number(splitValueChild[1])
                            : splitValueChild[1],
                        },
                      },
                    ],
                  });
                } else {
                  filterDefault.or.push({
                    [conditionKey]: {
                      [operator]: isTypeEnumNumber ? Number(item) : item,
                    },
                  });
                }
              });
            } else {
              filterDefault = {
                [conditionKey]: {[operator]: val},
              };
            }
          }
          if(valIsDate) {
            switch(operator) {
              case OperatorFilterNumberEnums.Equal: {
                const startTime = new Date(value);
                const monthKeepEqual: number = startTime.getMonth();
                const yearKeepEqual: number = startTime.getFullYear();
                startTime.setUTCHours(0, 0, 0, 0);
                startTime.setDate(new Date(value).getDate());
                startTime.setMonth(monthKeepEqual);
                startTime.setFullYear(yearKeepEqual);
                const endTime = new Date(value);
                endTime.setUTCHours(23, 59, 59, 999);
                endTime.setDate(new Date(value).getDate() + 1);
                filterDefault = {
                  [conditionKey]: {
                    [OperatorFilterNumberEnums.GreaterOrEqual]: startTime,
                  },
                };
                filterEqual = {
                  [conditionKey]: {
                    [OperatorFilterNumberEnums.LessOrEqual]: endTime,
                  },
                };
                break;
              }
              case OperatorFilterNumberEnums.Greater:
              case OperatorFilterNumberEnums.LessOrEqual: {
                const timeGreater = new Date(value);
                timeGreater.setUTCHours(23, 59, 59, 999);
                timeGreater.setDate(new Date(value).getDate() + 1);
                filterDefault = {
                  [conditionKey]: {[operator]: timeGreater},
                };
                break;
              }
              case OperatorFilterNumberEnums.Less:
              case OperatorFilterNumberEnums.GreaterOrEqual: {
                const timeLess = new Date(value);
                const monthKeepLess: number = timeLess.getMonth();
                const yearKeepLess: number = timeLess.getFullYear();
                timeLess.setUTCHours(0, 0, 0, 0);
                timeLess.setDate(new Date(value).getDate());
                timeLess.setMonth(monthKeepLess);
                timeLess.setFullYear(yearKeepLess);
                filterDefault = {
                  [conditionKey]: {[operator]: timeLess},
                };
                break;
              }
              default:
                break;
            }
          }
          if(isFilterOr !== -1) {
            const arr =
              columnsCustom[isFilterOr] &&
              columnsCustom[isFilterOr].queryMultipleKeys
                ? columnsCustom[isFilterOr].queryMultipleKeys!
                : [];
            const crtFilterContains: any = {};
            if(arr.length > 1 && operator !== "ne") {
              arr.forEach((i) => {
                if(isEnum) {
                  crtFilterContains[i] = {[operator]: val};
                } else {
                  crtFilterContains[`tolower(${i})`] = {[operator]: val};
                }
              });
              filterWith.push({or: crtFilterContains});
              break;
            } else {
              const rs = arr.map((i) => {
                if(isEnum) {
                  return {[i]: {[operator]: val}};
                }
                return {[`tolower(${i})`]: {[operator]: val}};
              });
              filterWith.push({and: rs});
              break;
            }
          }
          filterWith.push(filterDefault);
          if(filterEqual) {
            filterWith.push(filterEqual);
          }
          break;
        }
      }
    });
  }
  const AndObj: any = {
    and: [],
  };
  const filterWithNormal = filterWith.filter((item) => {
    const keyIncludeTotal = Object.keys(item)[0];
    return !keyIncludeTotal.includes("=");
  });
  const filterTotal = filterWith.filter((item) => {
    const keyIncludeTotal = Object.keys(item)[0];
    return keyIncludeTotal.includes("=");
  });
  const filterTotalString: string = renderFilterTotal(filterTotal);
  AndObj.and = filterWithNormal;
  if(filterWith.length > 0 || orderByAr.length > 0) {
    let buildQueryString = buildQuery({filter: AndObj, orderBy: orderByAr});
    if(buildQueryString.includes("/eq")) {
      buildQueryString = buildQueryString.replaceAll("/eq", "");
    }
    if(filterTotalString) {
      buildQueryString = `${buildQueryString}&${filterTotalString}`;
    }
    return buildQueryString;
  }
  return `${filterTotalString ? "&filterTotalString" : ""}`;
};

const renderFilterTotal = (filterTotal: any[]): string => {
  const filterTotalString: string[] = [];
  filterTotal.forEach((item) => {
    const key = Object.keys(item)[0];
    filterTotalString.push(`${key}${convertObjectToStringTotal(item[key])}`);
  });
  return filterTotalString.join("&");
};

const convertObjectToStringTotal = (
  value: Record<string, number | string>
): string => {
  let convertString: string = "";
  const key: string = Object.keys(value)[0];
  convertString = convertString + `${key} ${value[key]}`;
  return convertString;
};
